import React, { useState } from "react";
import { Header } from "../../../components/header";
import { NotificationsList } from "../components";

export const Notifications: React.FC = () => {
  const [onlyUnread, setOnlyUnread] = useState(true);

  return (
    <>
      <Header title="Notifications" subtitle="Vos alertes et rappels" />

      <div className="main-container">
        <div className="card">
          <div className="flex items-center gap-2 mb-3">
            <button
              type="button"
              onClick={() => setOnlyUnread(true)}
              className={`px-3 py-1.5 text-sm rounded-md transition-colors ${
                onlyUnread
                  ? "bg-primary-600 text-white"
                  : "bg-gray-100 dark:bg-zinc-800 text-gray-700 dark:text-zinc-300 hover:bg-gray-200 dark:hover:bg-zinc-700"
              }`}
            >
              Non lues
            </button>
            <button
              type="button"
              onClick={() => setOnlyUnread(false)}
              className={`px-3 py-1.5 text-sm rounded-md transition-colors ${
                !onlyUnread
                  ? "bg-primary-600 text-white"
                  : "bg-gray-100 dark:bg-zinc-800 text-gray-700 dark:text-zinc-300 hover:bg-gray-200 dark:hover:bg-zinc-700"
              }`}
            >
              Tout l'historique
            </button>
          </div>

          <NotificationsList onlyUnread={onlyUnread} />
        </div>
      </div>
    </>
  );
};
